export default "__VITE_ASSET__5a68b7be__"